export const SLIDER_LABEL_WIDTH = '64px';
export const SLIDER_READOUT_WIDTH = '40px';
export const SLIDER_TRACK_HEIGHT = '4px';
export const SLIDER_THUMB_SIZE = '16px';
